
export default {
    fetchSong: async (songId) => {
        return fetch('/api/song/' + songId, 
        {
            method: "GET", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    removeSong:  async (playlistId, songId) => {

        return fetch('/api/playlist/' + playlistId + '/song/' + songId,
            {
                method: "DELETE", 
                headers: {
                    "content-type": "application/json"
                }
            })
        
    },
    add: async (playlistId, songId) => {
  
        return fetch('/api/playlist/' + playlistId + '/song/' + songId, 
        {
            method: "PUT", 
            headers: {
                "content-type": "application/json"
            }
        })
        
    },
    cloneOrSaveSongOnPlaylist: async (playlistId, songId, params, lyric, songVersionId) => {
        let body = {};
        if (typeof lyric === 'object' && lyric !== null) {
            body = { ...lyric };
        } else {
            body = { lyric };
        }
        if (lyric && lyric.reverse_transpose !== undefined) {
            body.reverse_transpose = lyric.reverse_transpose;
        }
        if (songVersionId) {
            body.songVersionId = songVersionId;
        }
        return fetch('/api/playlist/' + playlistId + '/song/' + songId+'?'+new URLSearchParams(params).toString(), 
        {
            method: "POST", 
            body: JSON.stringify(body),
            headers: {
                "content-type": "application/json"
            }
        })
        
    },
    updateNote: async (playlistId, textId, text) => {
        return fetch('/api/playlist/' + playlistId + '/text/' + textId, 
        {
            method: "POST", 
            body: JSON.stringify({text}),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    fetchMedia: async (songId) => {
        return fetch('/api/song/medias/' + songId, 
        {
            headers: {
                "content-type": "application/json"
            }
        })
    },
    saveMusicNotation: async (playlistId, songId, notation) => {
        return fetch('/api/playlist/' + playlistId + '/song/' + songId + '/notation', 
        {
            method: "POST", 
            body: JSON.stringify(notation),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    fetchMusicNotation: async (playlistId, songId) => {
        return fetch('/api/playlist/' + playlistId + '/song/' + songId + '/notation', 
        {
            method: "GET", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    addPageToPlaylist: async (playlistId, pageData) => {
        return fetch('/api/playlist/' + playlistId + '/page', 
        {
            method: "POST", 
            body: JSON.stringify(pageData),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    savePlaylistSong: async (playlistId, songId, payload) => {
        return fetch('/api/playlist/' + playlistId + '/song/' + songId, 
        {
            method: "POST", 
            body: JSON.stringify(payload),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    updateSong: async (songId, songData) => {
        return fetch('/api/song/' + songId, 
        {
            method: "PUT", 
            body: JSON.stringify(songData),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    createSongVersion: async (songId, versionData) => {
        return fetch('/api/song/' + songId + '/versions', 
        {
            method: "POST", 
            body: JSON.stringify(versionData),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    fetchSongVersions: async (songId) => {
        return fetch('/api/song/' + songId + '/versions', 
        {
            method: "GET", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    fetchSongVersion: async (songId, versionId) => {
        return fetch('/api/song/' + songId + '/versions/' + versionId, 
        {
            method: "GET", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    updateSongVersion: async (songId, versionId, versionData) => {
        return fetch('/api/song/' + songId + '/versions/' + versionId, 
        {
            method: "PUT", 
            body: JSON.stringify(versionData),
            headers: {
                "content-type": "application/json"
            }
        })
    },
    deleteSongVersion: async (songId, versionId) => {
        return fetch('/api/song/' + songId + '/versions/' + versionId, 
        {
            method: "DELETE", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    restoreSongVersion: async (songId, versionId) => {
        return fetch('/api/song/' + songId + '/versions/' + versionId + '/restore', 
        {
            method: "POST", 
            headers: {
                "content-type": "application/json"
            }
        })
    },
    addFavoriteSong: async (songId, songVersionId) => {
        const body = { songId };
        if (songVersionId) {
            body.versionId = songVersionId;
        }
        return fetch('/api/user/favorite-songs', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "content-type": "application/json"
            }
        });
    },
    removeFavoriteSong: async (songId) => {
        return fetch('/api/user/favorite-songs/' + songId, {
            method: "DELETE",
            headers: {
                "content-type": "application/json"
            }
        });
    }
}
